// App.tsx
import { HashRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import { TeamsFxContext } from "./context/Context";
import config from "./components/config";
import Dashboard from "./pages/Dashboard";
import Chat from "./pages/Chat";
import AppTheme from "./shared-theme/AppTheme";
import { dataGridCustomizations } from "./components/theme/customizations/dataGrid";
import { Container, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";

// Componente interno per gestire il tracking della pagina corrente
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Salva la pagina corrente nel localStorage ogni volta che cambia la route
    localStorage.setItem('last_opened_page', location.pathname);
  }, [location.pathname]);

  return null; // Questo componente non renderizza nulla
}

export default function App() {
  const { loading, theme, themeString, teamsUserCredential } = useTeamsUserCredential({
    initiateLoginEndpoint: config.initiateLoginEndpoint,
    clientId: config.clientId,
  });

  const [initialRoute, setInitialRoute] = useState('/Dashboard');

  useEffect(() => {
    // Recupera l'ultima pagina visitata dal localStorage all'avvio dell'app
    const lastOpenedPage = localStorage.getItem('last_opened_page');

    console.log("ULTIMA PAGINA APERTA: " + lastOpenedPage)
    if (lastOpenedPage && lastOpenedPage !== '/') {
      setInitialRoute(lastOpenedPage);
    }
  }, []);

  if (loading) {
    return (
      <Container
        maxWidth="xl"
        sx={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (!teamsUserCredential) {
    return (
      <Container
        maxWidth="xl"
        sx={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Typography variant="h6" color="error">
          Login non effettuato. Ricarica l'app o accedi da Microsoft Teams.
        </Typography>
      </Container>
    );
  }

  return (
    <TeamsFxContext.Provider
      value={{
        theme,
        themeString,
        teamsUserCredential,
        apiUrl: "https://aion-asa.com/api/mapei/",
      }}
    >
      <AppTheme disableCustomTheme={false} themeComponents={{ ...dataGridCustomizations }}>
        <Container maxWidth="xl" sx={{ minHeight: "100vh" }}>
          <Router>
            <RouteTracker />
            <Routes>
              <Route path="/Chat/:ticketId/:operator_id" element={<Chat />} />
              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/" element={<Navigate to={initialRoute} replace />} />
              <Route path="/tab" element={<Navigate to={initialRoute} replace  />} />
            </Routes>
          </Router>
        </Container>
      </AppTheme>
    </TeamsFxContext.Provider>
  );
}